<template>
  <div v-bind:key="refreshKey">
    <b-table responsive
             v-handy-scroll
             v-bind:items="calls"
             v-bind:fields="fields"
             striped
             hover
             show-empty
             style="white-space: nowrap; padding-bottom: 10px"
    >
      <template #cell(time)="data">
        {{ data.value | momentDateTime }}
      </template>

      <template #cell(userName)="data">
        {{ data.value || getUserFullName(data.item.userId) }}
      </template>

      <template #cell(success)="data">
        <b-badge :variant="data.value === true ? 'light-success' : 'light-danger'">
          <i :class="data.value === true ? 'fas fa-phone' : 'fas fa-phone-slash'" class="mr-25"></i>
          {{ data.value === true ? $t('callLog.success') : $t('callLog.failed') }}
        </b-badge>
      </template>

      <template #cell(reason)="data">
        <span class="text-danger" v-if="data.item.success !== true">{{ data.value }}</span>
      </template>

      <template #empty>
        <div class="text-center text-muted py-1">{{ $t('callLog.noCalls') }}</div>
      </template>
    </b-table>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import mixinTable from '@/components/mixin/mixinTable';
import mixinNotifications from '@/components/mixin/mixinNotifications';
import mixinBase from '@/components/mixin/mixinBase';

export default {
  name: 'CallLogTable',
  mixins: [mixinBase, mixinTable, mixinNotifications],
  data: () => ({
    calls: [],
  }),
  props: {
    filters: {
      default: () => ({})
    },
  },
  watch: {
    filters: {
      deep: true,
      handler() {
        this.refresh();
      }
    }
  },
  created() {
    this.refresh();
  },
  computed: {
    ...mapGetters('data', ['getUserFullName']),

    fields() {
      return [
        { key: 'time', label: this.$t('callLog.time'), sortable: true },
        { key: 'userName', label: this.$t('callLog.agent'), sortable: true },
        { key: 'destination', label: this.$t('callLog.destination'), sortable: false },
        { key: 'extension', label: this.$t('callLog.extension'), sortable: false },
        { key: 'success', label: this.$t('callLog.status'), sortable: true },
        { key: 'reason', label: this.$t('callLog.reason'), sortable: false },
      ];
    },
  },
  methods: {
    ...mapActions('clients', ['getAllCallLogs']),

    refresh() {
      if (!this.filters.id) return;
      let loadingToken = this.setLoading();

      this.getAllCallLogs({ clientId: this.filters.id })
          .then(result => {
            this.calls = result.data || [];
          })
          .catch(err => {
            this.showErrorNotification(err);
            this.calls = [];
          })
          .finally(() => {
            this.setLoaded(loadingToken);
          });
    }
  }
};
</script>
